import React from 'react';
import { DateRange } from '../../lib/panelTypes';
import {
  PRESET_RANGES,
  rangeFromCalendarDates,
} from '../../lib/dateRange';

export { defaultRange, PRESET_RANGES } from '../../lib/dateRange';

const presets: { key: string; label: string }[] = [
  { key: 'today', label: 'Today' },
  { key: 'yesterday', label: 'Yesterday' },
  { key: '7d', label: '7d' },
  { key: '30d', label: '30d' },
  { key: '90d', label: '90d' },
];

interface Props {
  value: DateRange;
  onChange: (r: DateRange) => void;
}

const DateRangePicker: React.FC<Props> = ({ value, onChange }) => {
  const isCustom = value.label === 'Custom';

  const setCustom = (fromStr: string, toStr: string) => {
    if (!fromStr || !toStr) return;
    const [startDate, endDate] = fromStr <= toStr ? [fromStr, toStr] : [toStr, fromStr];
    onChange(rangeFromCalendarDates(startDate, endDate));
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="inline-flex rounded-md border border-gray-200 bg-white p-0.5">
        {presets.map((p) => {
          const active = value.label === PRESET_RANGES[p.key]().label;
          return (
            <button
              key={p.key}
              onClick={() => onChange(PRESET_RANGES[p.key]())}
              className={`px-3 py-1.5 text-sm font-medium rounded transition-colors ${
                active ? 'bg-indigo-600 text-white' : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              {p.label}
            </button>
          );
        })}
      </div>
      <div className="flex items-center gap-1 text-sm">
        <input
          type="date"
          value={value.startDate}
          onChange={(e) => setCustom(e.target.value, value.endDate)}
          className={`rounded border px-2 py-1 text-gray-700 ${isCustom ? 'border-indigo-400' : 'border-gray-200'}`}
        />
        <span className="text-gray-400">→</span>
        <input
          type="date"
          value={value.endDate}
          onChange={(e) => setCustom(value.startDate, e.target.value)}
          className={`rounded border px-2 py-1 text-gray-700 ${isCustom ? 'border-indigo-400' : 'border-gray-200'}`}
        />
      </div>
    </div>
  );
};

export default DateRangePicker;
